import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["player", "playOverlay"]
  static values = { postId: Number }
  
  connect() {
    console.log('Inline video controller connected for post', this.postIdValue)
    this.setupVideoHandlers()
  }
  
  setupVideoHandlers() {
    const video = this.playerTarget
    
    // Hide overlay when video starts playing
    video.addEventListener('play', () => {
      this.hidePlayOverlay()
    })
    
    // Show overlay when video is paused
    video.addEventListener('pause', () => {
      // Only show overlay if not at the end
      if (video.currentTime < video.duration - 0.5) {
        this.showPlayOverlay()
      }
    })
    
    // Show overlay when video ends
    video.addEventListener('ended', () => {
      this.showPlayOverlay()
      video.currentTime = 0 // Reset to beginning
    })
    
    // Initially hide native controls until interaction
    video.controls = false
  }
  
  togglePlay(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const video = this.playerTarget
    console.log('Toggle play clicked, video paused:', video.paused)
    
    if (video.paused) {
      // Show controls when playing
      video.controls = true
      video.play().then(() => {
        console.log(`Playing video for post ${this.postIdValue}`)
      }).catch(error => {
        console.error('Error playing video:', error)
        // Try muted autoplay as fallback
        video.muted = true
        video.play().catch(e => console.error('Muted play also failed:', e))
      })
    } else {
      video.pause()
    }
  }
  
  hidePlayOverlay() {
    if (this.hasPlayOverlayTarget) {
      this.playOverlayTarget.classList.add('opacity-0')
      this.playOverlayTarget.classList.add('pointer-events-none')
    }
  }
  
  showPlayOverlay() {
    if (this.hasPlayOverlayTarget) {
      this.playOverlayTarget.classList.remove('opacity-0')
      this.playOverlayTarget.classList.remove('pointer-events-none')
    }
  }
}